module.exports = __webpack_public_path__ + "img/jingdian_logo.81e4d01b.png";